import type { DetrixBrowserResourceEntry, DetrixNetworkEntry } from '../types';

/** Unified with NetworkPanel: page/XHR rows use this pseudo-type for chips. */
export const PAGE_CAPTURE_TYPE = 'page';

export type UnifiedNetworkRow =
  | { kind: 'network'; entry: DetrixNetworkEntry }
  | { kind: 'resource'; entry: DetrixBrowserResourceEntry };

export function mergeUnifiedNetworkRows(
  network: readonly DetrixNetworkEntry[],
  resources: readonly DetrixBrowserResourceEntry[],
): UnifiedNetworkRow[] {
  const nw = network.map((entry) => ({ kind: 'network' as const, entry }));
  const br = resources.map((entry) => ({ kind: 'resource' as const, entry }));
  return [...nw, ...br].sort((a, b) => {
    const ta = a.entry.timestamp;
    const tb = b.entry.timestamp;
    if (ta !== tb) return ta - tb;
    const sa = a.entry.sequence;
    const sb = b.entry.sequence;
    if (sa !== sb) return sa - sb;
    if (a.kind === b.kind) return 0;
    return a.kind === 'network' ? -1 : 1;
  });
}

export function filterUnifiedNetworkRows(
  rows: readonly UnifiedNetworkRow[],
  urlQuery: string,
  selectedTypes: readonly string[],
): UnifiedNetworkRow[] {
  const q = urlQuery.trim().toLowerCase();
  return rows.filter((row) => {
    const url = row.kind === 'network' ? row.entry.request.url : row.entry.url;
    const matchesText = q === '' || url.toLowerCase().includes(q);
    const rowType = row.kind === 'network' ? PAGE_CAPTURE_TYPE : row.entry.resourceType;
    const matchesType = selectedTypes.length === 0 || selectedTypes.includes(rowType);
    return matchesText && matchesType;
  });
}
